import React, { useState } from "react";
import PropTypes from "prop-types";
import Box from "@mui/material/Box";
import StyledModal from "../../../Modals/StyledModal/StyledModal";
import PrimaryTextField from "../../../Inputs/PrimaryTextField/PrimaryTextField";
import PrimaryButton from "../../../Buttons/PrimaryButton/PrimaryButton";
import SecondaryButton from "../../../Buttons/SecondaryButton/SecondaryButton";
import TertiaryButton from "../../../Buttons/TertiaryButton/TertiaryButton";
import { handleAltEnter } from "../../../../utils/keyboardShortcutHelpers";

export default function DynamicTabCreateModal({
  handleTabCreate,
  open,
  setOpen,
  isLoading
}) {
  const [name, setName] = useState("");

  const handleOpen = () => {
    setName("");
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const handleSave = () => {
    handleTabCreate(name);
    handleClose();
  };
  
  return (
    <Box onKeyDown={(e) => handleAltEnter(e, (isLoading || !name), handleSave)}>
      <Box marginTop="10px">
        <TertiaryButton
          label="New View +"
          onClick={handleOpen}
          color="primary.60"
        />
      </Box>
      <StyledModal
        label="New View"
        title="New View"
        open={open}
        handleClose={handleClose}
      >
        <Box sx={{ display: "flex", marginTop: "20px" }}>
          <PrimaryTextField
            id="tab-name"
            label="Name this view"
            onChange={setName}
            value={name}
            maxLength="10"
          />
          <Box sx={{ display: "flex", margin: "0 0 0 20px" }}>
            <Box sx={{ marginLeft: "auto", padding: "0 10px 5px 5px" }}>
              <SecondaryButton
                label="Cancel"
                onClick={handleClose}
                disabled={isLoading}
              />
            </Box>
            <Box sx={{ padding: "0 0 5px 5px" }}>
              <PrimaryButton
                label="Save"
                width="50px"
                onClick={handleSave}
                isLoading={isLoading}
                disabled={isLoading || !name}
              />
            </Box>
          </Box>
        </Box>
      </StyledModal>
    </Box>
  );
}

DynamicTabCreateModal.propTypes = {
  handleTabCreate: PropTypes.func.isRequired,
  open: PropTypes.bool.isRequired,
  setOpen: PropTypes.func.isRequired,
  isLoading: PropTypes.bool.isRequired
};